import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import type { SearchFriend } from '@/hooks/search/use-search-friends';
import cn from '@/utils/merge-class-names';
import SearchFriendResultItem from './search-friend-result-item';
import SessionLink from './session-link';

interface Props {
  friends: SearchFriend[];
  keyword?: string;
  className?: string;
}

export default function SearchFriendResultList({ friends, className }: Props) {
  const { t } = useTranslation();

  if (isEmpty(friends)) return null;

  return (
    <div className={cn('group/friend', className)}>
      <h4 className='flex h-6 mb-2 group-first/friend:mt-1 items-center px-5 text-body1 font-bold'>
        {t('conversation.contact.contact')}
      </h4>

      {friends.map((friend) => (
        <SessionLink
          key={friend.FriendID}
          sessionId={friend.ChatSessionID}>
          <SearchFriendResultItem friend={friend} />
        </SessionLink>
      ))}
    </div>
  );
}
